import { useEffect, useState } from "react"
import type { InfraStatus } from "@mc/types"
import { useFirstVisit } from "../components/onboarding/useFirstVisit.js"
import { Coachmark } from "../components/onboarding/Coachmark.js"
import { getHint } from "../components/onboarding/hints.js"
import { InfraStatusBanner } from "../components/infra/InfraStatusBanner.js"
import { ServerList } from "../components/servers/ServerList.js"
import { fetchInfraStatus } from "../api/infra.js"

/**
 * FR section 8/19 item 4: vista general con lista real de servidores
 * (GET /api/v1/servers) y estado de infraestructura (FR seccion 9). El
 * banner y la lista se resuelven independientemente: si uno falla, el
 * otro igual se muestra.
 */
export function DashboardPage() {
  const [isFirstVisit, dismiss] = useFirstVisit("dashboard-intro")
  const [infraStatus, setInfraStatus] = useState<InfraStatus | null>(null)

  useEffect(() => {
    let cancelled = false
    fetchInfraStatus()
      .then(({ infraStatus }) => {
        if (!cancelled) setInfraStatus(infraStatus)
      })
      .catch(() => {
        // El banner simplemente no aparece si esto falla; ServerList
        // reporta su propio error de forma independiente.
      })
    return () => {
      cancelled = true
    }
  }, [])

  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-6)" }}>
      <InfraStatusBanner infraStatus={infraStatus} />
      <ServerList />
    </div>
  )

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-6)" }}>
      <h1 style={{ fontSize: "var(--text-3xl)" }}>Dashboard</h1>

      {isFirstVisit ? (
        <Coachmark title={getHint("dashboard-intro").title} description={getHint("dashboard-intro").description} onDismiss={dismiss}>
          {content}
        </Coachmark>
      ) : (
        content
      )}
    </div>
  )
}
